import { MouseEventHandler } from 'react';

/** Growing list of image url endings needed to request the right sized image.
 * DAM and Contentful have different endings so ideally need to know the image source.
 *
 * Note: DAM will only listen to the largest number, whether that's width or height.
 * DAM will always return the same aspect ratio that the image was uploaded with.
 *
 * Syntax:
 * Dam: ?width=300 or ?height=300
 * Contentful: ?w=300 or ?h=300
 */
export enum ImageSize {
  W80 = '?w=80',
  W300 = '?w=300',
  Width300 = '?width=300',
  Width80 = '?width=80',
}

export interface IImage {
  url: string;
  alt: string;
  imgAriaLabel: string;
  handleCardClickEvent: MouseEventHandler<
    HTMLAnchorElement | HTMLButtonElement
  >;
  size?: string | ImageSize;
}
